import { useAtomValue } from 'jotai';
import { multiLingualDataAtom } from '../atoms/session-atoms';
export const useMultilingualWarning = () => {
  var _multiLingualData$cur;
  const multiLingualData = useAtomValue(multiLingualDataAtom);
  const isMultilingualEnabled = multiLingualData == null ? void 0 : multiLingualData.isMultilingualEnabled;
  const isNotMainLanguage = (multiLingualData == null || (_multiLingualData$cur = multiLingualData.currentLanguage) == null ? void 0 : _multiLingualData$cur.primary) === false;
  const shouldShowSecondaryLanguageWarning = Boolean(isMultilingualEnabled && isNotMainLanguage);
  return {
    isMultilingualEnabled,
    isNotMainLanguage,
    shouldShowSecondaryLanguageWarning
  };
};
//# sourceMappingURL=use-multilingual-warning.js.map